(() => {
  const DEBUG = true;
  const log = (...a) => DEBUG && console.log('[StickyBar]', ...a);

  if (window.__stickyBarInit) return;
  window.__stickyBarInit = true;

  const bars = document.querySelectorAll('.p-stickybar[data-section-id]');
  if (!bars.length) return log('no bars found');

  const trigger = (el, type) => { if (!el) return; el.dispatchEvent(new Event(type, { bubbles: true })); };

  const getMainVariantId = (productForm, mainRoot) => {
    const idInput = productForm ? productForm.querySelector('input[name="id"]') : null;
    if (idInput && idInput.value) return String(idInput.value);

    const vs = mainRoot ? mainRoot.querySelector('variant-selects') : document.querySelector('variant-selects');
    if (vs) {
      const json = vs.querySelector('script[type="application/json"][data-selected-variant]');
      if (json && json.textContent) {
        try {
          const obj = JSON.parse(json.textContent);
          if (obj && obj.id) return String(obj.id);
        } catch (e) {}
      }
    }
    return null;
  };

  const getMainVariantSelectsEl = (mainRoot, productForm) => {
    let vs = mainRoot ? mainRoot.querySelector('variant-selects') : null;
    if (vs) return vs;

    if (productForm) {
      vs = productForm.closest('[id^="MainProduct-"], [id^="ProductInfo-"], .product')?.querySelector('variant-selects');
      if (vs) return vs;
    }
    return document.querySelector('variant-selects');
  };

  const setMainVariantByOptions = async ({ productForm, mainRoot, targetOptions }) => {
    const vs = getMainVariantSelectsEl(mainRoot, productForm);
    if (!vs) return { ok: false, reason: 'no-variant-selects' };

    const fieldsets = Array.from(vs.querySelectorAll('fieldset'));
    let clicked = 0;

    for (let i = 0; i < targetOptions.length; i++) {
      const optVal = String(targetOptions[i] ?? '').trim();
      if (!optVal) continue;

      const scope = fieldsets[i] || vs;
      const radio =
        scope.querySelector(`input[type="radio"][value="${CSS.escape(optVal)}"]`) ||
        vs.querySelector(`input[type="radio"][value="${CSS.escape(optVal)}"]`);

      if (!radio) continue;

      if (!radio.checked) {
        radio.click();
        trigger(radio, 'change');
        clicked++;
      }
    }

    await new Promise(r => setTimeout(r, 80));
    const after = getMainVariantId(productForm, mainRoot);
    return { ok: clicked > 0, clicked, mainVariantIdAfter: after };
  };

  const waitForVariantId = async ({ productForm, mainRoot, targetVid, timeoutMs = 2000 }) => {
    const start = Date.now();
    while (Date.now() - start < timeoutMs) {
      const now = getMainVariantId(productForm, mainRoot);
      if (String(now || '') === String(targetVid)) return true;
      await new Promise(r => setTimeout(r, 50));
    }
    return false;
  };

  const clampQty = (el, val) => {
    const min = Number(el?.min || 1);
    const step = Number(el?.step || 1);
    let v = Math.max(min, Math.round(Number(val || 0) / step) * step);
    if (el?.max) v = Math.min(v, Number(el.max));
    if (!Number.isFinite(v) || v < min) v = min;
    return v;
  };

  const getSellingPlanFromForm = (form) => {
    if (!form) return '';
    const sp = form.querySelector('input[name="selling_plan"]');
    return sp ? String(sp.value || '') : '';
  };

  const setSellingPlanOnForm = (form, planId) => {
    if (!form) return;
    let sp = form.querySelector('input[name="selling_plan"]');
    if (planId) {
      if (!sp) {
        sp = document.createElement('input');
        sp.type = 'hidden';
        sp.name = 'selling_plan';
        form.appendChild(sp);
      }
      sp.value = String(planId);
      trigger(sp, 'change');
      trigger(sp, 'input');
    } else if (sp) {
      sp.parentNode.removeChild(sp);
    }
  };

  const withTemporarySellingPlan = (form, planId, submitFn) => {
    if (!form) return submitFn();

    const existing = form.querySelector('input[name="selling_plan"]');
    const had = !!existing;
    const prev = had ? String(existing.value || '') : '';
    const shouldSet = String(planId || '').trim();

    if (shouldSet) setSellingPlanOnForm(form, shouldSet);
    else setSellingPlanOnForm(form, '');

    const restore = () => {
      if (had) setSellingPlanOnForm(form, prev);
      else setSellingPlanOnForm(form, '');
    };

    try {
      submitFn();
    } finally {
      setTimeout(restore, 50);
      setTimeout(restore, 300);
      setTimeout(restore, 900);
    }
  };

  const populatePlanSelect = (planSelect) => {
    if (!planSelect) return;

    const prev = String(planSelect.value || '');

    planSelect.innerHTML = '';

    const optOT = document.createElement('option');
    optOT.value = '';
    optOT.textContent = 'One-time purchase';
    planSelect.appendChild(optOT);

    const cfgPlans = (window.SubscriptionWidgetConfig && window.SubscriptionWidgetConfig.shopifyPlans) || [];
    const unique = new Map();
    (cfgPlans || []).forEach((p) => {
      if (!p || typeof p.id === 'undefined') return;
      unique.set(String(p.id), p);
    });

    unique.forEach((p) => {
      const opt = document.createElement('option');
      opt.value = String(p.id);
      opt.textContent = String(p.name || `Plan ${p.id}`);
      planSelect.appendChild(opt);
    });

    const stillExists = Array.from(planSelect.options).some((o) => o.value === prev);
    if (stillExists) planSelect.value = prev;
  };

  bars.forEach((bar) => {
    if (bar.dataset.ready === '1') return;
    bar.dataset.ready = '1';

    if (bar.hasAttribute('hidden')) bar.removeAttribute('hidden');
    if (bar.parentElement !== document.body) document.body.appendChild(bar);

    const sectionId = bar.dataset.sectionId;

    const formId = bar.dataset.productFormId;
    const productForm =
      (formId && document.getElementById(formId)) ||
      document.querySelector('form[id^="product-form-"]') ||
      document.querySelector('product-form form');

    const mainRoot =
      document.getElementById(`MainProduct-${sectionId}`) ||
      document.getElementById(`ProductInfo-${sectionId}`) ||
      productForm?.closest('[id^="MainProduct-"], [id^="ProductInfo-"]') ||
      null;

    const variantSelect = bar.querySelector('.p-stickybar__variant-select');
    const qtyInputSticky = bar.querySelector('.p-stickybar__qty-input');
    const qtyBtns = bar.querySelectorAll('.p-stickybar__qty-btn');
    const planSelect = bar.querySelector('.p-stickybar__plan-select');
    const addBtn = bar.querySelector('.p-stickybar__btn');

    const getQtyInputMain = () => (productForm ? productForm.querySelector('input[name="quantity"]') : null);

    let variants = [];
    const variantsNode = document.getElementById(`StickyVariants-${sectionId}`);
    if (variantsNode) {
      try { variants = JSON.parse(variantsNode.textContent || '[]'); } catch (e) { variants = []; }
    }
    const variantById = new Map(variants.map(v => [String(v.id), v]));

    const getStickyVariantId = () => (variantSelect ? String(variantSelect.value || '') : String(bar.dataset.selectedVariantId || ''));
    const setStickyVariantId = (vid) => {
      if (variantSelect) variantSelect.value = String(vid);
      bar.dataset.selectedVariantId = String(vid);
    };

    let desiredQty = 1;
    let stickyInitiatedVariantChangeAt = 0;
    const STICKY_LOCK_MS = 800;

    const readDesiredQtyFromSticky = () => {
      if (!qtyInputSticky) return;
      desiredQty = clampQty(qtyInputSticky, qtyInputSticky.value || desiredQty || 1);
    };

    const applyDesiredQtyEverywhere = () => {
      const main = getQtyInputMain();

      if (qtyInputSticky) {
        const nextSticky = clampQty(qtyInputSticky, desiredQty);
        if (String(qtyInputSticky.value || '') !== String(nextSticky)) qtyInputSticky.value = String(nextSticky);
      }

      if (main) {
        const nextMain = clampQty(main, desiredQty);
        if (String(main.value || '') !== String(nextMain)) {
          main.value = String(nextMain);
          trigger(main, 'input');
          trigger(main, 'change');
        }
      }
    };

    const syncStickyFromMain = () => {
      const mainVid = getMainVariantId(productForm, mainRoot);
      if (!mainVid) return;

      if (Date.now() - stickyInitiatedVariantChangeAt < STICKY_LOCK_MS) return;

      const stickyVid = getStickyVariantId();
      if (stickyVid !== mainVid) setStickyVariantId(mainVid);

      const mainQty = getQtyInputMain();
      if (mainQty && qtyInputSticky) {
        const q = clampQty(mainQty, mainQty.value || 1);
        if (String(qtyInputSticky.value || '') !== String(q)) qtyInputSticky.value = String(q);
        desiredQty = q;
      }
    };

    const syncMainFromStickyVariantId = async (targetVid) => {
      const v = variantById.get(String(targetVid));
      if (!v) return false;

      stickyInitiatedVariantChangeAt = Date.now();
      readDesiredQtyFromSticky();

      await setMainVariantByOptions({
        productForm,
        mainRoot,
        targetOptions: Array.isArray(v.options) ? v.options : [],
      });

      await waitForVariantId({ productForm, mainRoot, targetVid, timeoutMs: 2200 });

      applyDesiredQtyEverywhere();
      setTimeout(applyDesiredQtyEverywhere, 120);
      setTimeout(applyDesiredQtyEverywhere, 350);
      setTimeout(applyDesiredQtyEverywhere, 700);

      setTimeout(() => { stickyInitiatedVariantChangeAt = 0; }, STICKY_LOCK_MS);
      return true;
    };

    if (variantSelect) {
      variantSelect.addEventListener('change', async () => {
        const targetVid = String(variantSelect.value || '');
        if (!targetVid) return;
        await syncMainFromStickyVariantId(targetVid);
      });
    }

    qtyBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        if (!qtyInputSticky) return;
        const delta = Number(btn.dataset.delta || 0);
        const next = clampQty(qtyInputSticky, Number(qtyInputSticky.value || 0) + delta);
        qtyInputSticky.value = String(next);
        desiredQty = next;
        applyDesiredQtyEverywhere();
      });
    });

    if (qtyInputSticky) {
      qtyInputSticky.addEventListener('input', () => {
        desiredQty = clampQty(qtyInputSticky, qtyInputSticky.value || 1);
        applyDesiredQtyEverywhere();
      });
      qtyInputSticky.addEventListener('change', () => {
        desiredQty = clampQty(qtyInputSticky, qtyInputSticky.value || 1);
        applyDesiredQtyEverywhere();
      });
    }

    document.addEventListener('input', (e) => {
      const t = e.target;
      if (!t || !(t instanceof Element)) return;
      if (!productForm) return;
      if (!t.matches('input[name="quantity"]')) return;
      if (!productForm.contains(t)) return;
      if (!qtyInputSticky) return;
      desiredQty = clampQty(t, t.value || 1);
      if (String(qtyInputSticky.value || '') !== String(desiredQty)) qtyInputSticky.value = String(desiredQty);
    }, true);

    document.addEventListener('change', (e) => {
      const t = e.target;
      if (!t || !(t instanceof Element)) return;
      if (!productForm) return;

      if (t.matches('input[name="quantity"]') && productForm.contains(t) && qtyInputSticky) {
        desiredQty = clampQty(t, t.value || 1);
        if (String(qtyInputSticky.value || '') !== String(desiredQty)) qtyInputSticky.value = String(desiredQty);
        return;
      }

      if (t.matches('input[type="radio"]')) {
        const vs = getMainVariantSelectsEl(mainRoot, productForm);
        if (vs && vs.contains(t)) setTimeout(syncStickyFromMain, 80);
      }
    }, true);

    const observeTargets = [];
    const vs = getMainVariantSelectsEl(mainRoot, productForm);
    if (productForm) observeTargets.push(productForm);
    if (vs) observeTargets.push(vs);

    observeTargets.forEach((node) => {
      const mo = new MutationObserver(() => {
        syncStickyFromMain();
        applyDesiredQtyEverywhere();
      });
      mo.observe(node, { childList: true, subtree: true, attributes: true });
    });

    if (planSelect) {
      populatePlanSelect(planSelect);

      bar.dataset.stickyPlanId = String(planSelect.value || '');

      planSelect.addEventListener('change', () => {
        bar.dataset.stickyPlanId = String(planSelect.value || '');
      });

      let tries = 0;
      const pollPlans = () => {
        const prev = String(planSelect.value || '');
        populatePlanSelect(planSelect);
        if (Array.from(planSelect.options).some(o => o.value === prev)) planSelect.value = prev;
        if (++tries < 25) setTimeout(pollPlans, 300);
      };
      setTimeout(pollPlans, 300);
    }

    if (addBtn && productForm) {
      addBtn.addEventListener('click', async (e) => {
        e.preventDefault();

        if (variantSelect) {
          const targetVid = String(variantSelect.value || '');
          if (targetVid) await syncMainFromStickyVariantId(targetVid);
        }

        if (qtyInputSticky) {
          desiredQty = clampQty(qtyInputSticky, qtyInputSticky.value || 1);
          applyDesiredQtyEverywhere();
        }

        const planId = String(bar.dataset.stickyPlanId || '').trim();

        withTemporarySellingPlan(productForm, planId, () => {
          if (typeof productForm.requestSubmit === 'function') productForm.requestSubmit();
          else productForm.submit();
        });
      });
    }

    const triggerSelector = bar.dataset.triggerSelector || '#product-tabs-accordion';
    const offset = parseInt(bar.dataset.triggerOffset || '0', 10);
    const minScroll = parseInt(bar.dataset.minScroll || '60', 10);

    let triggerEl = document.querySelector(triggerSelector);
    let baselineY = window.pageYOffset || document.documentElement.scrollTop || 0;

    const trigBottom = () => triggerEl ? triggerEl.getBoundingClientRect().bottom + (window.pageYOffset || document.documentElement.scrollTop || 0) : Infinity;

    const onScroll = () => {
      const y = window.pageYOffset || document.documentElement.scrollTop || 0;
      const viewBottom = y + window.innerHeight;
      const shouldShow =
        y > baselineY + minScroll &&
        !!triggerEl &&
        viewBottom >= (trigBottom() - offset);

      bar.classList.toggle('is-visible', !!shouldShow);
    };

    let rafId;
    const tick = () => { cancelAnimationFrame(rafId); rafId = requestAnimationFrame(onScroll); };
    window.addEventListener('scroll', tick, { passive: true });
    window.addEventListener('resize', tick, { passive: true });

    requestAnimationFrame(() => {
      const mainVid = getMainVariantId(productForm, mainRoot);
      if (mainVid) setStickyVariantId(mainVid);

      const mainQty = getQtyInputMain();
      if (mainQty && mainQty.value) desiredQty = clampQty(mainQty, mainQty.value);
      else if (qtyInputSticky && qtyInputSticky.value) desiredQty = clampQty(qtyInputSticky, qtyInputSticky.value);

      applyDesiredQtyEverywhere();
      syncStickyFromMain();
      onScroll();
    });

    let tries = 0;
    const findTriggerLoop = () => {
      triggerEl = document.querySelector(triggerSelector);
      if (!triggerEl && tries < 30) { tries++; setTimeout(findTriggerLoop, 200); return; }
      requestAnimationFrame(onScroll);
    };
    if (!triggerEl) findTriggerLoop();
  });
})();
